// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import jquery from 'jquery';
window.$ = window.jquery = jquery;
require("jquery-ui")
require("@nathanvda/cocoon")

import "bootstrap"
import "@fortawesome/fontawesome-free/css/all"

require("@nathanvda/cocoon")

//Custom JS
import "custom/show-img"
import "custom/format_money"
import "custom/calculate_product_sale_price"
import "custom/autocomplete"
import "custom/on_sale"
import "custom/view_cart"
import "custom/filter_company"
import "custom/on_payroll"
import "custom/get_adquirer"

require('data-confirm-modal')

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// Hide alerts
$( document ).ready(function() {
  setTimeout(function(){
    $(".alert .close").click();
  }, 6000);  
});